import { useAppDispatch, useAppSelector } from "../store"
import { connectHandler } from "../utils/connectHandler"
import CopyToClipboard from "./CopyToClipboard"
import ContentCopyIcon from "@mui/icons-material/ContentCopy"
import { Box, Grid, IconButton, Stack, TextField } from "@mui/material"
import Button from "@mui/material/Button"
import Typography from "@mui/material/Typography"
import React from "react"
import { generateReferralLink } from "../utils/referralUtils"

export const ReferralProgram = ({ view }) => {
  const dispatch = useAppDispatch()
  const { address } = useAppSelector((state) => state.user.user)
  const getWallet = () => {
    connectHandler(dispatch)
  }

  const { user } = useAppSelector((state) => state.user)

  // Генерируем реферальную ссылку
  const referralLink = user.address ? generateReferralLink(user.address) : ""

  return (
    <Box
      sx={{
        mt: {
          xs: 4,
          sm: 6,
          md: 8,
        },
      }}
    >
      <Typography variant="h2" textAlign="center" gutterBottom>
        Referral Program
      </Typography>

      <Typography variant="subtitle1" textAlign="left" sx={{ mb: 2 }}>
        Invite your friends to buy{" "}
        <span className="primary">
          NFT Boxes with {view === "turrets" ? "Turrets" : "Commanders"}
        </span>{" "}
        and earn 15% commission from their purchase!
      </Typography>

      <Stack spacing={1} sx={{ pl: 5, mb: 2 }}>
        <ul className="customList">
          <li>Rewards are credited immediately after the purchase.</li>
          <li>
            You receive your earnings in USDT, ready to withdraw instantly to
            your wallet.
          </li>
        </ul>
      </Stack>

      <Grid container rowSpacing={3} columnSpacing={0} className="d-flex">
        <Grid item xs={12}>
          <Box
            sx={{
              background: "rgba(255, 255, 255, .05)",
              p: 3,
              borderRadius: 2,
            }}
          >
            <Typography variant="h5">Your Referral Link:</Typography>
            {!address ? (
              <>
                <Typography gutterBottom>
                  Connect your wallet to get referral link
                </Typography>
                <Button variant="contained" onClick={getWallet} size="small">
                  Connect Wallet
                </Button>
              </>
            ) : (
              <Grid container spacing={2} sx={{ mt: 0 }}>
                <Grid item xs={11}>
                  <TextField
                    label="Your Referral Link:"
                    variant="outlined"
                    size="small"
                    value={referralLink}
                    fullWidth
                    disabled
                  />
                </Grid>
                <Grid item xs>
                  <CopyToClipboard>
                    {({ copy }) => (
                      <IconButton
                        onClick={() => copy(referralLink)}
                        sx={{
                          border: "1px solid rgba(255, 255, 255, 0.5)",
                          height: 44,
                          width: 44,
                        }}
                      >
                        <ContentCopyIcon />
                      </IconButton>
                    )}
                  </CopyToClipboard>
                </Grid>
              </Grid>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}
